module.exports = __webpack_public_path__ + "static/TruenoSBd-8df1e6013ff929d0f612d4929fd0dc86.woff";